import React, { useEffect, useState } from "react";
// import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from "react-bootstrap/Form";

import SearchIcon from "@mui/icons-material/Search";
import AccountIcon from "@mui/icons-material/AccountBalance";
import ReportIcon from "@mui/icons-material/WarningAmber";
import FinanceIcon from "@mui/icons-material/AttachMoney";
import PlusIcon from "@mui/icons-material/AddCircle";
import Accordion from "react-bootstrap/Accordion";
import Mobile2 from "../../Common/Mobile2";
import Loading from "../../Common/Loading";
import { useFaq } from "./Hooks";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
const FAQ = ({ isApp }) => {
  const [sortDrawer, setSortDrawer] = useState(false);
  const [value, setValue] = useState();
  const { data, loading, form, setForm, getData } = useFaq();
  useEffect(() => {
    getData();
  }, []);

  const handleChangeCountry = () => {

  }

  if (loading) {
    return <Loading />;
  }
  else if (isApp) {
    return (
      <>

        <FormControl variant="filled" style={{ width: "100%" }}>
          {<InputLabel id="demo-simple-select-filled-label">انتخاب دسته بندی</InputLabel>}
          <Select value={value} onChange={e => handleChangeCountry(e)} fullWidth className="slFilter">
            {data.categories
              ? data.categories.map(cat => {
                return (
                  <MenuItem value={cat.title}>{cat.title}</MenuItem>
                );
              })
              : <MenuItem value={"..."}>...</MenuItem>
            }
          </Select>
        </FormControl>
      </>
    )
  }
  return (
    <>
      <div id="faq-page">
        <div className="faq-top-container">
          <p className="h2 text-white mb-2 mb-md-4 mt-3 mt-md-1">
            چه سوالی برات پیش آمده؟
          </p>
          <div className="d-flex search-box">
            <Form.Control type="search" placeholder="جست و جو کنید" />
            <button className="btn">
              <SearchIcon color="#fff" />
            </button>
          </div>

          <div className="mt-3 faq-icons">
            {data.categories &&
              data.categories.map(cat => {
                return (
                  <button
                    onClick={() => setSortDrawer(1)}
                    className={
                      "mx-1 mx-sm-2 mb-2" +
                      (sortDrawer === 1 ? " faq-btn-active " : "")
                    }
                  >
                    <img src={cat.photo} alt={cat.title} />
                    <span>{cat.title}</span>
                  </button>
                );
              })}
          </div>
        </div>
        <div className="container accordion-container mt-4">
          <div className="row">
            <div className="col-12">
              {data.questions.map(item => (
                <Accordion>
                  <div className="mb-3" key={item.id}>
                    <Accordion.Toggle
                      as="div"
                      eventKey={item.id}
                      className="accordion-header"
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <h2 className="h6 me-3">{item.q}</h2>
                        <PlusIcon />
                      </div>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey={item.id}>
                      <p className="px-4 py-4"> {item.a} </p>
                    </Accordion.Collapse>
                  </div>
                </Accordion>
              ))}
            </div>
            <div className="col-12">
              <Mobile2 />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FAQ;
